import React from 'react';
import { motion } from 'framer-motion';
import './Terms.css';

const Terms = () => {
  return (
    <div className="terms-page">
      <div className="container">
        <motion.div
          className="terms-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1>Terms of Service</h1>
          <p className="last-updated">Last updated: February 12, 2024</p>
          
          <div className="terms-section">
            <h2>Acceptance of Terms</h2>
            <p>
              By accessing and using LogCrest's software, including mobile applications, web applications, 
              SDKs, APIs, and documentation, you agree to be bound by these Terms of Service. If you do not 
              agree to these terms, please do not use our services.
            </p>
          </div>

          <div className="terms-section">
            <h2>Usage and License</h2>
            <p>
              You agree to use LogCrest's resources only for their intended purposes and in compliance with 
              applicable laws and regulations. You are responsible for maintaining the confidentiality of your 
              account information and for all activities that occur under your account.
            </p>
          </div>

          <div className="terms-section">
            <h2>Prohibited Activities</h2>
            <p>The following activities are strictly prohibited:</p>
            <ul>
              <li>Unauthorized access to our systems or services</li>
              <li>Disruption or interference with our services</li>
              <li>Attempts to copy, reverse-engineer, or modify our software</li>
              <li>Use of our services for illegal or harmful purposes</li>
              <li>Violation of any applicable laws or regulations</li>
            </ul>
          </div>

          <div className="terms-section">
            <h2>Intellectual Property</h2>
            <p>
              All content, features, and functionality of LogCrest's services are owned by LogCrest and are 
              protected by international copyright, trademark, and other intellectual property laws. You may 
              not use our intellectual property without our express written permission.
            </p>
          </div>

          <div className="terms-section">
            <h2>Service Availability</h2>
            <p>
              We strive to provide reliable service, but we do not guarantee that our services will be 
              uninterrupted or error-free. We reserve the right to modify, suspend, or discontinue any 
              part of our services at any time without notice.
            </p>
          </div>

          <div className="terms-section">
            <h2>Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, LogCrest shall not be liable for any indirect, 
              incidental, special, consequential, or punitive damages, including but not limited to loss 
              of profits, data, or use, arising out of or relating to your use of our services.
            </p>
          </div>

          <div className="terms-section">
            <h2>Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms of Service at any time. We will notify users of 
              any material changes by posting the new terms on our website. Your continued use of our 
              services after such changes constitutes acceptance of the new terms.
            </p>
          </div>

          <div className="terms-section">
            <h2>Contact Information</h2>
            <p>
              If you have any questions about these Terms of Service, please contact us at:
            </p>
            <ul>
              <li>Email: legal@logcrest.com</li>
              <li>Address: Bangalore, India</li>
            </ul>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Terms;
